<template>
  <component :is="template">
    <template v-for="slot in slotsList" v-slot:[slot]="{height, type}">
      <DashboardSlot class="elevation-1" :slotKey="slot" :height="height" :type="type || null" :key="slot"/>
    </template>
    <template v-slot:news>
      <v-card shaped height="300">
        <NewsSlider/>
      </v-card>
    </template>
    <template v-slot:documents>
      <v-card shaped height="300">
        <DocumentsList />
      </v-card>
    </template>
  </component>
</template>

<script>
import DocumentsList from '@/components/Document/DocumentsList'
import NewsSlider from '@/components/News/NewsSlider'
import Gutenberg from '@/components/Dashboard/Templates/Gutenberg'
import Hugo from '@/components/Dashboard/Templates/Hugo'
import Lovelace from '@/components/Dashboard/Templates/Lovelace'
import NotreDame from '@/components/Dashboard/Templates/NotreDame'
import DashboardSlot from '@/components/Dashboard/DashboardSlot'
import { DEFAULT_SLOTS } from '@/config/dashboard'

export default {
  name: 'DashboardRender',
  components: { DashboardSlot, DocumentsList, NewsSlider, Gutenberg, Hugo, Lovelace, NotreDame },
  props: {
    template: { type: String, required: true },
    slots: { type: Object, required: true }
  },
  computed: {
    slotsList () {
      return Object.keys(DEFAULT_SLOTS)
    }
  }
}
</script>